"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var QuestionIcon = function QuestionIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M8 .15A7.85 7.85 0 1 0 15.85 8 7.85 7.85 0 0 0 8 .15zM9 14H7v-2h2zm1.158-5.566C9.468 9.09 9 9.488 9 10.337V11H7v-1c0-2.022 2.93-2.428 2.93-4.413a1.501 1.501 0 0 0-1.58-1.624c-.832 0-1.238.323-1.449 1.315A3.624 3.624 0 0 0 6.838 6H5.105l.039-.803c.213-1.568 1.388-2.472 3.223-2.472a2.721 2.721 0 0 1 2.985 2.816 3.203 3.203 0 0 1-1.194 2.893z"
    }) : _react["default"].createElement("path", {
      d: "M7.5 0A7.5 7.5 0 1 0 15 7.5 7.509 7.509 0 0 0 7.5 0zm.001 14.1A6.6 6.6 0 1 1 14.1 7.5a6.608 6.608 0 0 1-6.599 6.6zM7.5 10.5a1 1 0 1 1-1 1 1 1 0 0 1 1-1zM8 9H7a3.046 3.046 0 0 1 1.282-2.51c.47-.462.736-.746.732-1.217a1.324 1.324 0 0 0-1.46-1.27 1.418 1.418 0 0 0-1.548 1.394h-1c0-3.09 5.009-3.154 5.008-.128a2.617 2.617 0 0 1-1.032 1.935C8.462 7.715 8 7.995 8 9z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm1 19h-2v-2h2zm1.112-6.488A2.567 2.567 0 0 0 13 15.999h-2a4.85 4.85 0 0 1 2.329-4.375A3.492 3.492 0 0 0 15 8.999a3 3 0 1 0-6 0H7a5 5 0 1 1 10 0c0 2.004-1.218 3.344-2.888 4.513z"
    }) : _react["default"].createElement("path", {
      d: "M12 14h-1a4.62 4.62 0 0 1 1.803-3.755c.672-.66 1.203-1.182 1.197-2.049A2.188 2.188 0 0 0 11.607 6a2.419 2.419 0 0 0-2.624 2.39h-1a3.19 3.19 0 0 1 1.163-2.557A3.88 3.88 0 0 1 11.606 5 3.173 3.173 0 0 1 15 8.193a3.732 3.732 0 0 1-1.496 2.765A3.636 3.636 0 0 0 12 14zm-1.5 3.5a1 1 0 1 0 1-1 1 1 0 0 0-1 1zm11.5-6A10.5 10.5 0 1 1 11.5 1 10.497 10.497 0 0 1 22 11.5zm-.9 0a9.6 9.6 0 1 0-9.6 9.6 9.61 9.61 0 0 0 9.6-9.6z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M15.5 1A14.499 14.499 0 1 0 30 15.499 14.5 14.5 0 0 0 15.5 1zm1.533 23.283a.761.761 0 0 1-.761.76H14.75a.761.761 0 0 1-.76-.76V22.76a.761.761 0 0 1 .76-.761h1.522a.761.761 0 0 1 .76.76zm1.333-7.906c-1.159 1.1-1.377 1.418-1.377 2.89V20h-3v-1.198c0-2.081.574-2.587 1.922-3.934l.52-.493a4.538 4.538 0 0 0 1.709-3.317 2.482 2.482 0 0 0-2.607-2.688 2.9 2.9 0 0 0-2.544 2.155A5.794 5.794 0 0 0 12.937 12H9.99v-.712A5.49 5.49 0 0 1 15.561 6C18.91 6 21 7.901 21 10.976a6.762 6.762 0 0 1-2.634 5.4z"
  }) : _react["default"].createElement("path", {
    d: "M15.5 1A14.5 14.5 0 1 0 30 15.5 14.517 14.517 0 0 0 15.5 1zm0 28A13.5 13.5 0 1 1 29 15.5 13.515 13.515 0 0 1 15.5 29zm.5-9h-1c0-2.959 1.227-3.919 2.371-5.207.916-1.031 1.639-1.846 1.629-3.264C19 9.104 17.08 8 15.167 8 13.16 8 11 9.194 11 11.817h-1a4.523 4.523 0 0 1 1.648-3.628A5.549 5.549 0 0 1 15.168 7C17.637 7 20 8.555 20 11.525a5.598 5.598 0 0 1-1.881 3.932C17.043 16.668 16 17.421 16 20zm-.5 4.5a1 1 0 1 1 1-1 1.002 1.002 0 0 1-1 1z"
  }));
};

var _default = QuestionIcon;
exports["default"] = _default;